import Splide from "@splidejs/splide";


document.addEventListener( 'DOMContentLoaded', function() {
  const sliderItem = document.querySelector('.js--widget__slider');
  if (sliderItem) {
    var splide = new Splide( sliderItem, {
      perPage: 5,
      gap: 24,
      arrowPath: 'M27.1339 19.6161C27.622 20.1043 27.622 20.8957 27.1339 21.3839L14.6339 33.8839C14.1457 34.372 13.3543 34.372 12.8661 33.8839C12.378 33.3957 12.378 32.6043 12.8661 32.1161L24.4822 20.5L12.8661 8.88388C12.378 8.39573 12.378 7.60427 12.8661 7.11612C13.3543 6.62796 14.1457 6.62796 14.6339 7.11612L27.1339 19.6161Z',
      pagination : false,
      breakpoints: {
        768: {
          perPage: 1,
          width: '100%',
        },
        1280: {
          perPage: 3,
        },
      },
    } );
    splide.mount();
  }

} );
